"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsAuctionHouse__factory = void 0;
const ethers_1 = require("ethers");
class NounsAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsAuctionHouse__factory = NounsAuctionHouse__factory;
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IERC20Upgradeable",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ERC20PaymentReleased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "PayeeAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "PaymentReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "PaymentReleased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsToken",
                name: "_nouns",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "payees_",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "shares_",
                type: "uint256[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract INounsToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "payee",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "account",
                type: "address",
            },
        ],
        name: "release",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "release",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "released",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "released",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "shares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "token",
                type: "address",
            },
        ],
        name: "totalReleased",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalReleased",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061322b806100206000396000f3fe6080604052600436106101c65760003560e01c80638456cb59116100f7578063ce7c2ac211610095578063e33b7de311610064578063e33b7de3146105e8578063ec91f2a4146105fd578063f25efffc14610613578063f2fde38b1461062857600080fd5b8063ce7c2ac214610546578063ce9c7c0d1461057c578063d79779b21461059c578063db2e1eed146105d257600080fd5b80639454fd37116100d15780639454fd37146104b05780639852595c146104d0578063a4d0a17e14610506578063b296024d1461051b57600080fd5b80638456cb591461045d5780638b83209b146104725780638da5cb5b1461049257600080fd5b8063406072a911610164578063659dd2b41161013e578063659dd2b41461038b5780637120334b1461039e578063715018a6146103be5780637d9f6db5146103d357600080fd5b8063406072a91461030257806348b75044146103485780635c975abb1461036857600080fd5b806336ebdb38116101a057806336ebdb38146102985780633a98ef39146102b85780633f4ba83a146102cd5780633fc8cef3146102e257600080fd5b80630fb5a6b414610214578063191655871461023e5780632de45f181461026057600080fd5b3661020f577f6ef95f06320e7a25a04a175ca677b7052bdd97131872c2192525a629f51be77033604080516001600160a01b0390921682523460208301520160405180910390a1005b600080fd5b34801561022057600080fd5b5061022b6101005481565b6040519081526020015b60405180910390f35b34801561024a57600080fd5b5061025e610259366004612cbc565b610648565b005b34801561026c57600080fd5b5060fb54610280906001600160a01b031681565b6040516001600160a01b039091168152602001610235565b3480156102a457600080fd5b5061025e6102b3366004612e93565b610654565b3480156102c457600080fd5b5060c95461022b565b3480156102d957600080fd5b5061025e610719565b3480156102ee57600080fd5b5060fc54610280906001600160a01b031681565b34801561030e57600080fd5b5061022b61031d366004612cfb565b6001600160a01b03918216600090815260cf6020908152604080832093909416825291909152205490565b34801561035457600080fd5b5061025e610363366004612cfb565b6107b5565b34801561037457600080fd5b5060335460ff166040519015158152602001610235565b61025e610399366004612e61565b610a67565b3480156103aa57600080fd5b5061025e6103b9366004612e61565b610dd6565b3480156103ca57600080fd5b5061025e610e65565b3480156103df57600080fd5b50610101546101025461010354610104546101055461042594939291906001600160a01b0381169074010000000000000000000000000000000000000000900460ff1686565b6040805196875260208701959095529385019290925260608401526001600160a01b03166080830152151560a082015260c001610235565b34801561046957600080fd5b5061025e610ec9565b34801561047e57600080fd5b5061028061048d366004612e61565b610f2b565b34801561049e57600080fd5b506097546001600160a01b0316610280565b3480156104bc57600080fd5b5061025e6104cb366004612d34565b610f5b565b3480156104dc57600080fd5b5061022b6104eb366004612cbc565b6001600160a01b0316600090815260cc602052604090205490565b34801561051257600080fd5b5061025e6110d5565b34801561052757600080fd5b5060ff8054610534911681565b60405160ff9091168152602001610235565b34801561055257600080fd5b5061022b610561366004612cbc565b6001600160a01b0316600090815260cb602052604090205490565b34801561058857600080fd5b5061025e610597366004612e61565b61118e565b3480156105a857600080fd5b5061022b6105b7366004612cbc565b6001600160a01b0316600090815260ce602052604090205490565b3480156105de57600080fd5b5061022b60fe5481565b3480156105f457600080fd5b5060ca5461022b565b34801561060957600080fd5b5061022b60fd5481565b34801561061f57600080fd5b5061025e61121d565b34801561063457600080fd5b5061025e610643366004612cbc565b6112d8565b610651816113b7565b50565b6097546001600160a01b031633146106b35760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064015b60405180910390fd5b60ff80547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00168282169081179091556040519081527fec5ccd96cc77b6219e9d44143df916af68fc169339ea7de5008ff15eae13450d906020015b60405180910390a150565b6097546001600160a01b031633146107735760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b61077b61158c565b6101035415806107a657506101055474010000000000000000000000000000000000000000900460ff165b156107b3576107b3611646565b565b6001600160a01b038116600090815260cb60205260409020546108405760405162461bcd60e51b815260206004820152602660248201527f5061796d656e7453706c69747465723a206163636f756e7420686173206e6f2060448201527f736861726573000000000000000000000000000000000000000000000000000060648201526084016106aa565b6001600160a01b038216600090815260ce60205260408120546040517f70a082310000000000000000000000000000000000000000000000000000000081523060048201526001600160a01b038516906370a082319060240160206040518083038186803b1580156108b157600080fd5b505afa1580156108c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108e99190612e7a565b6108f39190612f3f565b90506000610931838361092c87876001600160a01b03918216600090815260cf6020908152604080832093909416825291909152205490565b6117e9565b9050806109a65760405162461bcd60e51b815260206004820152602b60248201527f5061796d656e7453706c69747465723a206163636f756e74206973206e6f742060448201527f647565207061796d656e7400000000000000000000000000000000000000000060648201526084016106aa565b6001600160a01b03808516600090815260cf60209081526040808320938716835292905290812080548392906109dd908490612f3f565b90915550506001600160a01b038416600090815260ce602052604081208054839290610a0a908490612f3f565b90915550610a1b9050848483611831565b604080516001600160a01b038581168252602082018490528616917f3be5b7a71e84ed12875d241991c70855ac5817d847039e17a9d895c1ceb0f18a910160405180910390a250505050565b60026065541415610aba5760405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016106aa565b60026065556040805160c081018252610101548082526101025460208301526101035492820192909252610104546060820152610105546001600160a01b038116608083015274010000000000000000000000000000000000000000900460ff16151560a0820152908214610b715760405162461bcd60e51b815260206004820152601760248201527f4e6f756e206e6f7420757020666f722061756374696f6e00000000000000000060448201526064016106aa565b80606001514210610bc45760405162461bcd60e51b815260206004820152600f60248201527f41756374696f6e2065787069726564000000000000000000000000000000000060448201526064016106aa565b60fe54341015610c165760405162461bcd60e51b815260206004820152601f60248201527f4d7573742073656e64206174206c65617374207265736572766550726963650060448201526064016106aa565b60ff80546020830151606492610c2d921690612f92565b610c379190612f57565b8160200151610c469190612f3f565b341015610cbd576040805162461bcd60e51b81526020600482015260248101919091527f4d7573742073656e64206d6f7265207468616e206c617374206269642062792060448201527f6d696e426964496e6372656d656e7450657263656e7461676520616d6f756e7460648201526084016106aa565b60808101516001600160a01b03811615610cdf57610cdf8183602001516118b6565b346101025561010580547fffffffffffffffffffffffff0000000000000000000000000000000000000000163317905560fd54606083015160009190610d26904290612fcf565b1090508015610d485760fd54610d3c9042612f3f565b60608401819052610104555b8251604080513381523460208201528315158183015290517f1159164c56f277e6fc99c11731bd380e0347deb969b75523398734c252706ea39181900360600190a28015610dcb57825160608401516040519081527f6e912a3a9105bdd2af817ba5adc14e6c127c1035b5b648faa29ca0d58ab8ff4e9060200160405180910390a25b505060016065555050565b6097546001600160a01b03163314610e305760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b60fd8190556040518181527f1b55d9f7002bda4490f467e326f22a4a847629c0f2d1ed421607d318d25b410d9060200161070e565b6097546001600160a01b03163314610ebf5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b6107b360006119d1565b6097546001600160a01b03163314610f235760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b6107b3611a3b565b600060cd8281548110610f4057610f406130c9565b6000918252602090912001546001600160a01b031692915050565b600054610100900460ff1680610f74575060005460ff16155b610fe65760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611008576000805461ffff19166101011790555b611010611ae1565b611018611bb2565b611020611c67565b61102a8383611d24565b611032611a3b565b60fb80546001600160a01b03808c167fffffffffffffffffffffffff00000000000000000000000000000000000000009283161790925560fc8054928b169290911691909117905560fd87905560fe86905560ff80548187167fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0090911617905561010084905580156110ca576000805461ff00191690555b505050505050505050565b60335460ff166111275760405162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f742070617573656400000000000000000000000060448201526064016106aa565b6002606554141561117a5760405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016106aa565b6002606555611187611df9565b6001606555565b6097546001600160a01b031633146111e85760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b60fe8190556040518181527f6ab2e127d7fdf53b8f304e59d3aab5bfe97979f52a85479691a6fab27a28a6b29060200161070e565b600260655414156112705760405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c0060448201526064016106aa565b600260655560335460ff16156112c85760405162461bcd60e51b815260206004820152601060248201527f5061757361626c653a207061757365640000000000000000000000000000000060448201526064016106aa565b6112d0611df9565b611187611646565b6097546001600160a01b031633146113325760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106aa565b6001600160a01b0381166113ae5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084016106aa565b610651816119d1565b6001600160a01b038116600090815260cb60205260409020546114425760405162461bcd60e51b815260206004820152602660248201527f5061796d656e7453706c69747465723a206163636f756e7420686173206e6f2060448201527f736861726573000000000000000000000000000000000000000000000000000060648201526084016106aa565b600061144d60ca5490565b6114579047612f3f565b9050600061147f838361092c866001600160a01b0316600090815260cc602052604090205490565b9050806114f45760405162461bcd60e51b815260206004820152602b60248201527f5061796d656e7453706c69747465723a206163636f756e74206973206e6f742060448201527f647565207061796d656e7400000000000000000000000000000000000000000060648201526084016106aa565b6001600160a01b038316600090815260cc60205260408120805483929061151c908490612f3f565b925050819055508060ca60008282546115359190612f3f565b9091555061154590508382612100565b604080516001600160a01b0385168152602081018390527fdf20fd1e76bc69d672e4814fafb2c449bba3a5369d8359adf9e05e6fde87b056910160405180910390a1505050565b60335460ff166115de5760405162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f742070617573656400000000000000000000000060448201526064016106aa565b603380547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b60fb60009054906101000a90046001600160a01b03166001600160a01b0316631249c58b6040518163ffffffff1660e01b8152600401602060405180830381600087803b15801561169657600080fd5b505af19250505080156116e4575060408051601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01682019092526116e191810190612e7a565b60015b611724576116f0613127565b806308c379a014156117185750611705613143565b80611710575061171a565b610651611a3b565b505b3d6000803e3d6000fd5b6101005442906000906117379083612f3f565b6040805160c08101825285815260006020808301829052828401879052606083018590526080830182905260a09092018190526101018790556101025561010385905561010483905561010580547fffffffffffffffffffffff000000000000000000000000000000000000000000169055815185815290810183905291925084917fd6eddd1118d71820909c1197aa966dbc15ed6f508554252169cc3d5ccac756ca910160405180910390a2505050565b60c9546001600160a01b038416600090815260cb6020526040812054909183916118139086612f92565b61181d9190612f57565b6118279190612fcf565b90505b9392505050565b604080516001600160a01b038416602482015260448082018490528251808303909101815260649091019091526020810180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff167fa9059cbb000000000000000000000000000000000000000000000000000000001790526118b1908490612219565b505050565b6118c082826122fe565b6119cd5760fc60009054906101000a90046001600160a01b03166001600160a01b031663d0e30db0826040518263ffffffff1660e01b81526004016000604051808303818588803b15801561191457600080fd5b505af1158015611928573d6000803e3d6000fd5b505060fc546040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b03878116600483015260248201879052909116935063a9059cbb92506044019050602060405180830381600087803b15801561199557600080fd5b505af11580156119a9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118b19190612cd9565b5050565b609780546001600160a01b038381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b60335460ff1615611a8e5760405162461bcd60e51b815260206004820152601060248201527f5061757361626c653a207061757365640000000000000000000000000000000060448201526064016106aa565b603380547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586116293390565b600054610100900460ff1680611afa575060005460ff16155b611b6c5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611b8e576000805461ffff19166101011790555b611b9661237c565b611b9e61243c565b8015610651576000805461ff001916905550565b600054610100900460ff1680611bcb575060005460ff16155b611c3d5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611c5f576000805461ffff19166101011790555b611b9e612525565b600054610100900460ff1680611c80575060005460ff16155b611cf25760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611d14576000805461ffff19166101011790555b611d1c61237c565b611b9e6125eb565b600054610100900460ff1680611d3d575060005460ff16155b611daf5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611dd1576000805461ffff19166101011790555b611dd961237c565b611de383836126a1565b80156118b1576000805461ff0019169055505050565b6040805160c08101825261010154815261010254602082015261010354918101829052610104546060820152610105546001600160a01b038116608083015274010000000000000000000000000000000000000000900460ff16151560a082015290611ea75760405162461bcd60e51b815260206004820152601460248201527f41756374696f6e206861736e277420626567756e00000000000000000000000060448201526064016106aa565b8060a0015115611ef95760405162461bcd60e51b815260206004820181905260248201527f41756374696f6e2068617320616c7265616479206265656e20736574746c656460448201526064016106aa565b8060600151421015611f4d5760405162461bcd60e51b815260206004820152601860248201527f41756374696f6e206861736e277420636f6d706c65746564000000000000000060448201526064016106aa565b61010580547fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff167401000000000000000000000000000000000000000017905560808101516001600160a01b03166120235760fb5481516040517f42966c680000000000000000000000000000000000000000000000000000000081526001600160a01b03909216916342966c6891611fec9160040190815260200190565b600060405180830381600087803b15801561200657600080fd5b505af115801561201a573d6000803e3d6000fd5b505050506120b0565b60fb54608082015182516040517f23b872dd0000000000000000000000000000000000000000000000000000000081523060048201526001600160a01b03928316602482015260448101919091529116906323b872dd90606401600060405180830381600087803b15801561209757600080fd5b505af11580156120ab573d6000803e3d6000fd5b505050505b80516080820151602080840151604080516001600160a01b039094168452918301527fc9f72b276a388619c6d185d146697036241880c36654b1a3ffdad07c24038d99910160405180910390a250565b804710156121505760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e636500000060448201526064016106aa565b6000826001600160a01b03168260405160006040518083038185875af1925050503d806000811461219d576040519150601f19603f3d011682016040523d82523d6000602084013e6121a2565b606091505b50509050806118b15760405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c207260448201527f6563697069656e74206d6179206861766520726576657274656400000000000060648201526084016106aa565b600061226e826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166128879092919063ffffffff16565b8051909150156118b1578080602001905181019061228c9190612cd9565b6118b15760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e60448201527f6f7420737563636565640000000000000000000000000000000000000000000060648201526084016106aa565b6040805160008082526020820190925281906001600160a01b0385169061753090859060405161232e9190612eae565b600060405180830381858888f193505050503d806000811461236c576040519150601f19603f3d011682016040523d82523d6000602084013e612371565b606091505b509095945050505050565b600054610100900460ff1680612395575060005460ff16155b6124075760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015611b9e576000805461ffff19166101011790558015610651576000805461ff001916905550565b600054610100900460ff1680612455575060005460ff16155b6124c75760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff161580156124e9576000805461ffff19166101011790555b603380547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001690558015610651576000805461ff001916905550565b600054610100900460ff168061253e575060005460ff16155b6125b05760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff161580156125d2576000805461ffff19166101011790555b60016065558015610651576000805461ff001916905550565b600054610100900460ff1680612604575060005460ff16155b6126765760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff16158015612698576000805461ffff19166101011790555b611b9e336119d1565b600054610100900460ff16806126ba575060005460ff16155b61272c5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084016106aa565b600054610100900460ff1615801561274e576000805461ffff19166101011790555b81518351146127c55760405162461bcd60e51b815260206004820152603260248201527f5061796d656e7453706c69747465723a2070617965657320616e64207368617260448201527f6573206c656e677468206d69736d61746368000000000000000000000000000060648201526084016106aa565b60008351116128165760405162461bcd60e51b815260206004820152601a60248201527f5061796d656e7453706c69747465723a206e6f2070617965657300000000000060448201526064016106aa565b60005b83518110156128705761285e848281518110612837576128376130c9565b6020026020010151848381518110612851576128516130c9565b6020026020010151612896565b8061286881613061565b915050612819565b5080156118b1576000805461ff0019169055505050565b60606118278484600085612ab7565b6001600160a01b0382166129125760405162461bcd60e51b815260206004820152602c60248201527f5061796d656e7453706c69747465723a206163636f756e74206973207468652060448201527f7a65726f2061646472657373000000000000000000000000000000000000000060648201526084016106aa565b600081116129625760405162461bcd60e51b815260206004820152601d60248201527f5061796d656e7453706c69747465723a2073686172657320617265203000000060448201526064016106aa565b6001600160a01b038216600090815260cb6020526040902054156129ee5760405162461bcd60e51b815260206004820152602b60248201527f5061796d656e7453706c69747465723a206163636f756e7420616c726561647960448201527f206861732073686172657300000000000000000000000000000000000000000060648201526084016106aa565b60cd8054600181019091557f83978b4c69c48dd978ab43fe30f077615294f938fb7f936d9eb340e51ea7db2e0180547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b038416908117909155600090815260cb6020526040902081905560c954612a6e908290612f3f565b60c955604080516001600160a01b0384168152602081018390527f40c340f65e17194d14ddddb073d3c9f888e3cb52b5aae0c6c7706b4fbc905fac910160405180910390a15050565b606082471015612b2f5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f60448201527f722063616c6c000000000000000000000000000000000000000000000000000060648201526084016106aa565b843b612b7d5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016106aa565b600080866001600160a01b03168587604051612b999190612eae565b60006040518083038185875af1925050503d8060008114612bd6576040519150601f19603f3d011682016040523d82523d6000602084013e612bdb565b606091505b5091509150612beb828286612bf6565b979650505050505050565b60608315612c0557508161182a565b825115612c155782518084602001fd5b8160405162461bcd60e51b81526004016106aa9190612eca565b600082601f830112612c4057600080fd5b81356020612c4d82612f1b565b604051612c5a8282613016565b8381528281019150858301600585901b87018401881015612c7a57600080fd5b60005b85811015612c9957813584529284019290840190600101612c7d565b5090979650505050505050565b803560ff81168114612cb757600080fd5b919050565b600060208284031215612cce57600080fd5b813561182a816131e0565b600060208284031215612ceb57600080fd5b8151801515811461182a57600080fd5b60008060408385031215612d0e57600080fd5b8235612d19816131e0565b91506020830135612d29816131e0565b809150509250929050565b600080600080600080600080610100898b031215612d5157600080fd5b612d5b89356131e0565b883597506020890135612d6d816131e0565b96506040890135955060608901359450612d8960808a01612ca6565b935060a0890135925060c089013567ffffffffffffffff80821115612dad57600080fd5b818b0191508b601f830112612dc157600080fd5b8135612dcc81612f1b565b604051612dd98282613016565b809150828152602081019150602085018f60208560051b8801011115612dfe57600080fd5b600095505b83861015612e2b578035612e16816131e0565b83526001959095019460209283019201612e03565b509550505060e08b0135915080821115612e4457600080fd5b50612e518b828c01612c2f565b9150509295985092959890939650565b600060208284031215612e7357600080fd5b5035919050565b600060208284031215612e8c57600080fd5b5051919050565b600060208284031215612ea557600080fd5b61182a82612ca6565b60008251612ec0818460208701612fe6565b9190910192915050565b6020815260008251806020840152612ee9816040850160208701612fe6565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169190910160400192915050565b600067ffffffffffffffff821115612f3557612f356130f8565b5060051b60200190565b60008219821115612f5257612f5261309a565b500190565b600082612f8d577f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b500490565b6000817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0483118215151615612fca57612fca61309a565b500290565b600082821015612fe157612fe161309a565b500390565b60005b83811015613001578181015183820152602001612fe9565b83811115613010576000848401525b50505050565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f830116810181811067ffffffffffffffff8211171561305a5761305a6130f8565b6040525050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8214156130935761309361309a565b5060010190565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600060033d11156131405760046000803e5060005160e01c5b90565b600060443d10156131515790565b6040517ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc803d016004833e81513d67ffffffffffffffff816024840111818411171561319f57505050505090565b82850191508151818111156131b75750505050505090565b843d87010160208285010111156131d15750505050505090565b61237160208286010187613016565b6001600160a01b038116811461065157600080fdfea2646970667358221220a31cfbb5b1e470d00218e32327ed48ae8a48b1dc9723bccefde919721357a24b64736f6c63430008060033";
